import React, { useRef } from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import classNames from 'classnames'
import './AccordionItem.scss'

const AccordionItem = ({ title, content, isOpen, onClick, fixedHeight, contentRenderer, color }) => {
  const contentRef = useRef(null)

  return (
    <div className='viso-accordion-item'>
      <div
        className={classNames(
          'viso-accordion-item__header',
          isOpen && `viso-text-${color} viso-bg-${color}-10 viso-border-${color}-10`
        )}
        onClick={onClick}
      >
        {title}
        <svg
          className={classNames(
            'viso-accordion-item__arrow',
            isOpen && 'viso-accordion-item__arrow--open'
          )}
          width='13'
          height='7'
          viewBox='0 0 13 7'
          fill='none'
        >
          <path d='M11.5664 1L6.56641 6L1.56641 1' stroke='#8B959E' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </div>
      <div
        ref={contentRef}
        className='viso-accordion-item__panel'
        style={{
          maxHeight: isOpen
            ? fixedHeight
              ? `${fixedHeight}px`
              : `${contentRef.current?.scrollHeight}px`
            : '0px'
        }}
      >
        <div
          style={{ height: fixedHeight }}
          className='viso-accordion-item__inner'
        >
          <Scrollbars
            autoHeight
            autoHide
            autoHideDuration={1}
            autoHeightMax={fixedHeight}
            autoHeightMin={fixedHeight}
            renderView={props => <div {...props} className='view' />}
          >
            {contentRenderer ? contentRenderer() : <div className='viso-accordion-item__content'>{content}</div>}
          </Scrollbars>
        </div>
      </div>
    </div>
  )
}

export default AccordionItem
